import { formatAmount } from "components/Strapi/StrapiPlanHero"
import { IPlanProps } from "components/UI/Plan"
import { PlansSelectorPrice } from "./PlansSelector"

const getBilling = (
  price: PlansSelectorPrice
): "yearly" | "quarterly" | "monthly" => {
  if (
    price.recurring.interval === "year" &&
    price.recurring.interval_count === 1
  ) {
    return "yearly"
  }
  if (
    price.recurring.interval === "month" &&
    price.recurring.interval_count === 3
  ) {
    return "quarterly"
  }
  if (
    price.recurring.interval === "month" &&
    price.recurring.interval_count === 1
  ) {
    return "monthly"
  }

  throw new Error("billing is wrong")
}

const getPlanTitle = (price: PlansSelectorPrice) => {
  const billing = getBilling(price)
  if (billing === "quarterly") return "3 Months"
  if (billing === "monthly") return "Monthly"
  if (billing === "yearly") return "Yearly"
}

const getAmountForQuantity = (price: PlansSelectorPrice, q: number) => {
  const t = price.tiers
    .sort((a, b) => (a.up_to || Infinity) - (b.up_to || Infinity))
    .find(t => t.up_to && t.up_to >= q)

  if (!t?.up_to && !t?.unit_amount)
    throw new Error("Invalid price for this quantity.")

  return (t?.unit_amount || 0) * q + (t?.flat_amount || 0)
}

const getPriceTitle = (price: PlansSelectorPrice) => {
  let amount = getAmountForQuantity(price, 1)
  const billing = getBilling(price)
  if (billing === "quarterly") amount /= 3
  if (billing === "yearly") amount /= 12
  return `${formatAmount(price.currency, amount, 2)} / month`
}

const getPriceInformation = (price: PlansSelectorPrice) => {
  const amount = getAmountForQuantity(price, 1)
  return `Taken as a single payment of ${formatAmount(
    price.currency,
    amount,
    2
  )}`
}

export const priceToPlanProps = (price: PlansSelectorPrice): IPlanProps => {
  return {
    planId: price.id,
    title: getPlanTitle(price) || "",
    description: "7 day free trial",
    priceLabel: getPriceTitle(price),
    priceInformation: getPriceInformation(price),
    // linkTo: ''
    button: {
      value: "Start Free Trial",
      theme: "primary",
      // backgroundColor:
    },
    badgeText: getBilling(price) === "yearly" ? "Best value" : undefined,
    extraResources: getBilling(price) === "yearly",
    highlighted: getBilling(price) === "yearly",
    showSam: getBilling(price) === "yearly",
  }
}
